/**
 * Build fields the API merges into regulatory style prompts (aligned with server buildStyleOptionsFromClinicalIntake).
 * @param {Record<string, unknown>|null|undefined} intake - latest clinical intake document
 * @param {Record<string, unknown>|null|undefined} [project] - trial project (canonical acronym / sponsor name)
 * @returns {Record<string, unknown>}
 */
import {
  resolveProjectSponsorName,
  resolveProjectTrialAcronym,
} from './projectIdentityFields';

export function buildGenerationStylePayload(intake, project = null) {
  const projectSponsorName = resolveProjectSponsorName(project);
  const projectTrialAcronym = resolveProjectTrialAcronym(project);

  if (!intake || typeof intake !== 'object') {
    return {
      ...(projectSponsorName ? { sponsorNameFull: projectSponsorName } : {}),
      ...(projectTrialAcronym ? { sponsorNameShort: projectTrialAcronym } : {}),
    };
  }
  const si = intake.study_identification || {};
  const so = intake.study_overview || {};
  const st = intake.study_treatments || {};
  const rr = intake.regulatory_requirements || {};
  const countries = String(rr.countries_for_submission || '').toLowerCase();

  let submissionRegion = 'US';
  if (
    /\b(ema|europe|european union|\beu\b|eea\b|uk\b|united kingdom|great britain|germany|france|italy|spain|netherlands|belgium|ireland|austria|switzerland|sweden|norway|denmark|finland|poland)\b/.test(
      countries,
    )
  ) {
    submissionRegion = 'EU';
  }
  if (/\b(united states|\bus\b|\busa\b|fda)\b/i.test(countries)) {
    submissionRegion = 'US';
  }
  if (intake.submission_region === 'EU' || intake.submission_region === 'US') {
    submissionRegion = intake.submission_region;
  }

  const sponsorNameFull =
    projectSponsorName ||
    si.sponsor_full_legal_name ||
    si.sponsor_name_full ||
    si.sponsor_legal_name ||
    '';
  const sponsorNameShort =
    projectTrialAcronym ||
    si.preferred_short_title ||
    so.study_short_title ||
    si.preferred_study_identifier ||
    '';
  const productName = st.regimen_arm_1 || st.investigational_product || st.ip_name || '';
  const therapeuticArea = so.therapeutic_area || so.disease_indication || '';

  const payload = {
    submissionRegion,
    documentType: 'protocol',
  };

  if (sponsorNameFull) payload.sponsorNameFull = sponsorNameFull;
  if (sponsorNameShort) payload.sponsorNameShort = sponsorNameShort;
  if (productName) payload.productName = productName;
  if (therapeuticArea) payload.therapeuticArea = therapeuticArea;

  return payload;
}
